import Verification from '../components/Verification.vue'
import { bootstrapPage } from '../bootstrapPage'

bootstrapPage(Verification)
